// Configuration objects for different environments
const PREPROD_CONFIG = Object.freeze({
  currentEnvironment: "preprod",

  deeplinkBaseUrl: {
    preprod: "https://genius.devinfinitylearn.in/",
    staging: "https://genius.devinfinitylearn.in/",
    loadtest: "https://genius.devinfinitylearn.in/",
    prod: "https://genius.infinitylearn.com/deeplink/exampage",
  },

  scholarshipTestBaseUrl: {
    preprod: "https://scholarshiptest.devinfinitylearn.in/",
    staging: "https://scholarshipteststaging.devinfinitylearn.in/",
    prod: "https://scholarshiptest.infinitylearn.com/",
  },

  baseUrl: {
    1: "https://inmobiusjob.devinfinitylearn.in/api", // pre-prod URL
  },

  gatewayBaseUrl: {
    1: "https://gatewayapi.devinfinitylearn.in/api", // preprod
  },

  inmobiusJobBaseUrl: {
    1: "https://inmobiusjob.devinfinitylearn.in/api", // preprod
  },

  schoolReportBaseUrl:
    "https://geniusreports.devinfinitylearn.in/school-report",

  gatewayApiSecretKey: "PMA4qXWFZ3uJstb8qtYWVjiFLgtAsm8UULe7cuhGydsdKcwJ", // preprod
  apiKey: "PMA4qXWFZ3uJstb8qtYWVjiFLgtAsm8UULe7cuhGydsdKcwJ", // preprod
  apiVersion: "v1",
  gatewayApiVersion: "v1",
  inmobiusJobApiVersion: "v1",

  roleMappings: {
    1: {
      5: "Super Admin",
      47: "MIS Team Admin",
      48: "General Manager",
      49: "Senior Manager",
      50: "Manager",
      51: "Execution Rep",
      52: "School Admin",
    },
  },

  hierarchy_role_ids: {
    1: {
      "Senior Manager": 49,
      Manager: 50,
      "Execution Rep": 51,
    },
  },
});

const STAGING_CONFIG = Object.freeze({
  currentEnvironment: "staging",

  deeplinkBaseUrl: {
    preprod: "https://genius.devinfinitylearn.in/",
    staging: "inmobiusstaging-ui.devinfinitylearn.in/",
    loadtest: "https://loadtestui.devinfinitylearn.in/",
    prod: "https://genius.infinitylearn.com/deeplink/exampage",
  },

  baseUrl: {
    1: "https://inmobiusstaging.devinfinitylearn.in/api", // staging URL
  },

  gatewayBaseUrl: {
    1: "https://gatewaystaging.devinfinitylearn.in/api", // staging gateway URL
  },

  inmobiusJobBaseUrl: {
    1: "https://inmobiusstaging.devinfinitylearn.in/api", // staging
  },

  schoolReportBaseUrl:
    "https://geniusreports.devinfinitylearn.in/school-report",

  gatewayApiSecretKey: "PMA4qXWFZ3uJstb8qtYWVjiFLgtAsm8UULe7cuhGydsdKcwJ", // staging
  apiKey: "PMA4qXWFZ3uJstb8qtYWVjiFLgtAsm8UULe7cuhGydsdKcwJ", // staging
  apiVersion: "v1",
  gatewayApiVersion: "v1",
  inmobiusJobApiVersion: "v1",

  roleMappings: {
    1: {
      5: "Super Admin",
      47: "MIS Team Admin",
      48: "General Manager",
      49: "Senior Manager",
      50: "Manager",
      51: "Execution Rep",
      52: "School Admin",
    },
  },

  hierarchy_role_ids: {
    1: {
      "Senior Manager": 49,
      Manager: 50,
      "Execution Rep": 51,
    },
  },
});

const LOADTEST_CONFIG = Object.freeze({
  currentEnvironment: "loadtest",

  deeplinkBaseUrl: {
    preprod: "https://genius.devinfinitylearn.in/",
    staging: "inmobiusstaging-ui.devinfinitylearn.in/",
    loadtest: "https://loadtestui.devinfinitylearn.in/",
    prod: "https://genius.infinitylearn.com/deeplink/exampage",
  },

  baseUrl: {
    1: "https://loadtestapi.devinfinitylearn.in/api", // loadtest URL - Update this with actual loadtest API URL
  },

  gatewayBaseUrl: {
    1: "https://testgatewaygcp.devinfinitylearn.in/api", // loadtest gateway URL - Update this with actual loadtest gateway URL
  },

  inmobiusJobBaseUrl: {
    1: "https://loadtestapi.devinfinitylearn.in/api", // loadtest - Update this with actual loadtest inmobius URL
  },

  schoolReportBaseUrl:
    "https://geniusreports.devinfinitylearn.in/school-report", // Update if loadtest has different reports URL

  gatewayApiSecretKey: "PMA4qXWFZ3uJstb8qtYWVjiFLgtAsm8UULe7cuhGydsdKcwJ", // loadtest - Update with actual loadtest secret key
  apiKey: "PMA4qXWFZ3uJstb8qtYWVjiFLgtAsm8UULe7cuhGydsdKcwJ", // loadtest - Update with actual loadtest API key
  apiVersion: "v1",
  gatewayApiVersion: "v1",
  inmobiusJobApiVersion: "v1",

  roleMappings: {
    1: {
      5: "Super Admin",
      47: "MIS Team Admin",
      48: "General Manager",
      49: "Senior Manager",
      50: "Manager",
      51: "Execution Rep",
      52: "School Admin",
    },
  },

  hierarchy_role_ids: {
    1: {
      "Senior Manager": 49,
      Manager: 50,
      "Execution Rep": 51,
    },
  },
});

const PRODUCTION_CONFIG = Object.freeze({
  currentEnvironment: "prod",

  deeplinkBaseUrl: {
    preprod: "https://genius.devinfinitylearn.in/",
    staging: "https://genius.devinfinitylearn.in/",
    loadtest: "https://genius.devinfinitylearn.in/",
    prod: "https://genius.infinitylearn.com/deeplink/exampage",
  },

  scholarshipTestBaseUrl: {
    preprod: "https://scholarshiptest.devinfinitylearn.in/",
    staging: "https://scholarshipteststaging.devinfinitylearn.in/",
    prod: "https://scholarshiptest.infinitylearn.com/",
  },

  baseUrl: {
    1: "https://inmobiusjob.infinitylearn.com/api", // prod URL
  },

  gatewayBaseUrl: {
    1: "https://gatewayapiinmobius.infinitylearn.com/api", // prod URL
  },

  inmobiusJobBaseUrl: {
    1: "https://inmobiusjob.infinitylearn.com/api", // prod
  },

  schoolReportBaseUrl: "https://geniusreports.infinitylearn.com/school-report",

  gatewayApiSecretKey: "MtgZCn5NMS5lgp7m0NYSvB9Rb7jOVvKZcDm5cLgTWjVXdFG0Js", //prod
  apiKey: "MtgZCn5NMS5lgp7m0NYSvB9Rb7jOVvKZcDm5cLgTWjVXdFG0Js", //prod
  apiVersion: "v1",
  gatewayApiVersion: "v1",
  inmobiusJobApiVersion: "v1",

  roleMappings: {
    1: {
      5: "Super Admin",
      45: "MIS Team Admin",
      46: "General Manager",
      47: "Senior Manager",
      48: "Manager",
      49: "Execution Rep",
      50: "School Admin",
    },
  },

  hierarchy_role_ids: {
    1: {
      "Senior Manager": 47,
      Manager: 48,
      "Execution Rep": 49,
    },
  },
});

// Function to determine current environment based on hostname
function getCurrentEnvironment() {
  if (typeof window !== "undefined" && window.location) {
    const hostname = window.location.hostname;

    // Production hostname
    if (hostname === "adminv2.inmobiusinfinitylearn.com") {
      return "production";
    }

    // Staging hostname
    if (hostname === "adminv2staging.devinfinitylearn.in") {
      return "staging";
    }

    // Loadtest hostname
    if (hostname === "loadtestui.devinfinitylearn.in") {
      return "loadtest";
    }

    // Preprod hostnames (including localhost and 127.0.0.1 for development)
    if (
      hostname === "adminpreprodv2.inmobiusinfinitylearn.com" ||
      hostname === "localhost" ||
      hostname === "127.0.0.1"
    ) {
      return "preprod";
    }
  }

  // Default fallback to preprod for development/unknown environments
  return "preprod";
}

// Export the appropriate configuration based on current hostname
const env = getCurrentEnvironment();
export const CONFIG_VARS =
  env === "production"
    ? PRODUCTION_CONFIG
    : env === "staging"
      ? STAGING_CONFIG
      : env === "loadtest"
        ? LOADTEST_CONFIG
        : PREPROD_CONFIG;
